import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { renderToStaticMarkup } from 'react-dom/server';

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./home.css";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";

// import soru ile compenant soru sirasinin ayni olmasi onemli yoksa slayt bozuluyor
import Carousel from "../components/Carousel";

import { EffectFade, Navigation, Pagination, Keyboard } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";


const Hipurin = () => {
  const [posts, setPosts] = useState([]);
  //const [postsh, setPostsh] = useState([]);
  const [sonuc02goster, setSonuc02] = useState([]);
  const [sonuc03goster, setSonuc03] = useState([]);
  const [sonuc04goster, setSonuc04] = useState([]);
  const [sonuc07goster, setSonuc07] = useState([]);
  const [sonuc08goster, setSonuc08] = useState([]);
  const [sonuc09goster, setSonuc09] = useState([]);
  const [sonuc11goster, setSonuc11] = useState([]);
  const [sonuc13goster, setSonuc13] = useState([]);
  const [sonuc15goster, setSonuc15] = useState([]);
  const [sonuc16goster, setSonuc16] = useState([]);
  const [sonuc17goster, setSonuc17] = useState([]);
  const [sonuc18goster, setSonuc18] = useState([]);
  const [sonuc31goster, setSonuc31] = useState([]);
  const [sonuc32goster, setSonuc32] = useState([]);
  const [sonuc44goster, setSonuc44] = useState([]);
  const location = useLocation();
  const postId = location.pathname.split("/")[2];
  const records = posts.slice();
  //const recordsh = postsh.slice();
  const sonuc19 = 1;
  const sonuc24 = 1;
  const sonuc11 = 1;

  useEffect(() => {
  
  // sunum bilgileri
    const fetchData = async () => {
      //console.log("use effect home calisti");
      try {
        //console.log("postId", postId);
        const res = await axios.get(
          `https://api.recordatifocus.com/sunum-bilgileri/${postId}`
        );
        //console.log("res", res.data);
        setPosts(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
// sunum bilbileri
// 
// Soru 01
    const soruBir = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-01/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru01 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc02goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_02.jpg"/></div>;
      	const sonuc03goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_03.jpg"/></div>;
      	const sonuc04goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_04.jpg"/></div>;
      	setSonuc02(sonuc02goster);
      	setSonuc03(sonuc03goster);
      	setSonuc04(sonuc04goster);
      } else {
      	const sonuc02goster = null;
      	const sonuc03goster = null;
      	const sonuc04goster = null;
      	setSonuc02(sonuc02goster);
      	setSonuc03(sonuc03goster);
      	setSonuc04(sonuc04goster);
      }
    };
  
    soruBir();

    
// soru 01
// 
// 
// 
// Soru 02
    const soruIki = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-02/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru02 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc07goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_07.jpg"/></div>;
      	const sonuc08goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_08.jpg"/></div>;
      	const sonuc09goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_09.jpg"/></div>;
      	setSonuc07(sonuc07goster);
      	setSonuc08(sonuc08goster);
      	setSonuc09(sonuc09goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc07goster = null;
      	const sonuc08goster = null;
      	const sonuc09goster = null;
      	setSonuc07(sonuc07goster);
      	setSonuc08(sonuc08goster);
      	setSonuc09(sonuc09goster);
      }
    };
  
    soruIki();
// soru 02
// 
// 
// 
// Soru 03
    const soruUc = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-03/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru031 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc11goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_11.jpg"/></div>;
      	setSonuc11(sonuc11goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc11goster = null;
      	setSonuc11(sonuc11goster);
      }
    };
  
    soruUc();
// soru 03
// 
// 
// 
// 
// 
// 
// Soru 04
    const soruDort = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-04/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru04 yanlis orani:", sonuc);

      if (sonuc >= sonuc24) {
      	const sonuc13goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_13.jpg"/></div>;
      	setSonuc13(sonuc13goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc13goster = null;
      	setSonuc13(sonuc13goster);
      }
    };
  
    soruDort();
// soru 04
// 
// 
// 
// Soru 05
    const soruBes = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-05/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru05 yanlis orani:", sonuc);

      if (sonuc >= sonuc24) {
      	const sonuc15goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_15.jpg"/></div>;
      	setSonuc15(sonuc15goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc15goster = null;
      	setSonuc15(sonuc15goster);
      }
    };
  
    soruBes();
// soru 05
// 
// 
// 
// Soru 06
    const soruAlti = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-06/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru06 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc16goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_16.jpg"/></div>;
      	setSonuc16(sonuc16goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc16goster = null;
      	setSonuc16(sonuc16goster);
      }
    };
  
    soruAlti();
// soru 06
// 
// 
// 
// Soru 07
    const soruYedi = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-07/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru07 yanlis orani:", sonuc);

      if (sonuc >= sonuc24) {
      	const sonuc17goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_17.jpg"/></div>;
      	setSonuc17(sonuc17goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc17goster = null;
      	setSonuc17(sonuc17goster);
      }
    };
  
    soruYedi();
// soru 07
// 
// 
// 
// Soru 08
    const soruSekiz = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-08/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru081 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc18goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_18.jpg"/></div>;
      	setSonuc18(sonuc18goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc18goster = null;
      	setSonuc18(sonuc18goster);
      }
    };
  
    soruSekiz();
// soru 081
// 
// 
// 
// Soru 082
    const soruDokuz = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-09/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru082 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc31goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_31.jpg"/></div>;
      	const sonuc32goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_32.jpg"/></div>;
      	setSonuc31(sonuc31goster);
      	setSonuc32(sonuc32goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc31goster = null;
      	const sonuc32goster = null;
      	setSonuc31(sonuc31goster);
      	setSonuc32(sonuc32goster);
      }
    };
  
    soruDokuz();
// soru 082
// 
// 
// 
// Soru 
    const soruOn = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/gyno-lomexin-10/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      let sonuc = 1;
      console.log("Soru091 yanlis orani:", sonuc);

      if (sonuc >= sonuc11) {
      	const sonuc44goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_44.jpg"/></div>;
      	setSonuc44(sonuc44goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc44goster = null;
      	setSonuc44(sonuc44goster);
      }
    };
  
    soruOn();
// 
// 

  
  
  }, [postId]);


const slide01goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_01.jpg"/></div>;
const slide02goster = sonuc02goster;
const slide03goster = sonuc03goster;
const slide04goster = sonuc04goster;
const slide05goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_05.jpg"/></div>;
const slide06goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_06.jpg"/></div>;
const slide07goster = sonuc07goster;
const slide08goster = sonuc08goster;
const slide09goster = sonuc09goster;
const slide10goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_10.jpg"/></div>;
const slide11goster = sonuc11goster;
const slide12goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_12.jpg"/></div>;
const slide13goster = sonuc13goster;
const slide14goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_14.jpg"/></div>;
const slide15goster = sonuc15goster;
const slide16goster = sonuc16goster;
const slide17goster = sonuc17goster;
const slide18goster = sonuc18goster;
const slide19goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_19.jpg"/></div>;
const slide20goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_20.jpg"/></div>;
const slide21goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_21.jpg"/></div>;
const slide22goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_22.jpg"/></div>;
const slide23goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_23.jpg"/></div>;
const slide24goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_24.jpg"/></div>;
const slide25goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_25.jpg"/></div>;
const slide26goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_26.jpg"/></div>;
const slide27goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_27.jpg"/></div>;
const slide28goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_28.jpg"/></div>;
const slide29goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_29.jpg"/></div>;
const slide30goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_30.jpg"/></div>;
const slide31goster = sonuc31goster;
const slide32goster = sonuc32goster;
const slide33goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_33.jpg"/></div>;
const slide34goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_34.jpg"/></div>;
const slide35goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_35.jpg"/></div>;
const slide36goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_36.jpg"/></div>;
const slide37goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_37.jpg"/></div>;
const slide38goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_38.jpg"/></div>;
const slide39goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_39.jpg"/></div>;
const slide40goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_40.jpg"/></div>;
const slide41goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_41.jpg"/></div>;
const slide42goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_42.jpg"/></div>;
const slide43goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_43.jpg"/></div>;
const slide44goster = sonuc44goster;
const slide45goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_45.jpg"/></div>;
const slide46goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_46.jpg"/></div>;
const slide47goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/gyno_lomexin/Gyno-Lomexin_DocFocus_MART26_Page_47.jpg"/></div>;

const slides = [slide01goster, slide02goster, slide03goster, slide04goster, slide05goster, slide06goster, slide07goster, slide08goster, slide09goster, slide10goster, slide11goster, slide12goster, slide13goster, slide14goster, slide15goster, slide16goster, slide17goster, slide18goster, slide19goster, slide20goster, slide21goster, slide22goster, slide23goster, slide24goster, slide25goster, slide26goster, slide27goster, slide28goster, slide29goster, slide30goster, slide31goster, slide32goster, slide33goster, slide34goster, slide35goster, slide36goster, slide37goster, slide38goster, slide39goster, slide40goster, slide41goster, slide42goster, slide43goster, slide44goster, slide45goster, slide46goster, slide47goster];
var filtered = slides.filter(Boolean);
const listItems = filtered.map((number) =>  <SwiperSlide>{number}</SwiperSlide>);

  return (
    <>
      <Swiper
        effect={"fade"}
        pagination={{
          type: "fraction",
        }}
        keyboard={{
          enabled: true,
        }}
        navigation={true}
        modules={[EffectFade, Navigation, Pagination, Keyboard]}
        className="mySwiper"
      >
        {listItems}
      </Swiper>
  
      {records.map((post) => (
        <div className="container d-none my-4" key={post.id}>
          <div className="sunum-adi">Sunum Adi: {post.title}</div>
  		  <div className="sunum-adi">Sunum Tarihi: {post.tarih}</div>
  		  <div className="sunum-adi">Sunan Kisi: {post.uid}</div>
        </div>
      ))}

<div className={`col d-flex flex-column align-items-center justify-content-center pb-5 footer-${location.pathname.split("/")[2]}`}>

<div className="card mx-2" style={{width: "8rem"}}>
  <a href="https://qr.recordatifocus.com/hippurinkub" className="text-decoration-none text-black" target="_blank"><img alt="" src="https://www.recordatifocus.com/images/gyno-lomexin-kub.png" className="img-fluid" /></a>
  <div className="p-1" style={{backgroundColor: "#632a7b"}}>
    <a href="https://qr.recordatifocus.com/hippurinkub" className="text-decoration-none text-white" target="_blank"><div className="text-center small fw-bold">GYNO-LOMEXIN</div></a>
  </div>
</div>
<p class="pb-5 mx-3 fw-bold footer-link-undefined">www.recordati.com.tr</p>
</div>

  
    </>
  );
};

export default Hipurin;
